import styled from "styled-components";

import { color } from "../../theme/color";

/** The top of a list or detail pane: a title with buttons next to it. */
export const PaneHeader = styled.header`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 20px 16px 8px;
`;

export const PaneTitle = styled.h1`
    flex: 1;
    min-width: 0;
    margin: 0;
    font-size: 26px;
    font-weight: 700;
    letter-spacing: -0.02em;
`;

export const List = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0 8px 16px;
    overflow: auto;
    flex: 1;
`;

/** A row in a list that opens something. The open one has `aria-current`. */
export const Row = styled.button`
    width: 100%;
    min-height: 64px;
    padding: 10px 12px;
    display: flex;
    align-items: center;
    gap: 12px;
    border: 0;
    border-radius: 12px;
    background: transparent;
    text-align: left;
    cursor: pointer;

    &[aria-current="true"] {
        background: ${color.accentSoft};
    }
`;

export const RowText = styled.span`
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

export const RowTitle = styled.span`
    font-size: 16px;
    font-weight: 600;
`;

export const RowDetail = styled.span`
    font-size: 14px;
    color: ${color.textMuted};
`;

/** What a list says when it's empty, with a way to fill it. */
export const Empty = styled.div`
    margin: 24px 16px;
    padding: 24px;
    border: 1px dashed ${color.borderStrong};
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    color: ${color.textSoft};
`;
